const STORAGE_KEYS = {
  ORG_ID: "ORG_ID",
};

export default STORAGE_KEYS;
